import { css } from "@emotion/react";


export const emotionGlobalCss = css`
.react-dropdown-select{
  text-align: left;
  border: 0 !important;
  height: 50px;
 cursor: pointer;
}
.react-dropdown-select-content{
  display: block !important;
}
.react-dropdown-select-input{
 cursor: pointer;
 border: 0;
 padding: 0;
}
.react-dropdown-select-input:focus{
  border: 0
}
.react-dropdown-select-dropdown{
  width: 200px !important;
}


`  